import React, { useRef } from "react";
import BOListTemplates from "../DocumentTemplates/bolisttemplates";
import DocuTemplates from "../DocumentTemplates/docutemplates";
import { displayCountryDesc } from "../Services/services";
import arrow_gray from "../../images/arrow_gray_product.gif";
import { useFileUploadInfoData } from "../Contexts/fileUploadInfoProvider";
import PrintWindow from "../printWindow/printWindow";
import ReactToPrint from "react-to-print";
import "./confirmation.css";

interface Props {
  selectedPage: string;
  country: string;
  selectedOption: string;
  setSelectedPage: React.Dispatch<React.SetStateAction<string>>;
  setSelectedCountry: React.Dispatch<React.SetStateAction<string>>;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
}

const FileUploadConfirmation: React.FC<Props> = (props) => {
  const { country, selectedOption, setSelectedPage } = props;
  const componentRef = useRef(null);
  const { fileUploadData, setUploadData } = useFileUploadInfoData();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    switch (event.currentTarget.id) {
      case "sameMarket":
        setSelectedPage("FileUploadInfo");
        break;
      case "diffMarket":
        setSelectedPage("MarketSelection");
        setUploadData({});
        break;
      case "finished":
        setSelectedPage("BolDescription");
        break;
    }
  };

  return (
    <div>
      <div hidden>
        <PrintWindow fileUploadData={fileUploadData} ref={componentRef} />
      </div>
      <p>Upload Beneficial Owner List - Step Confirmation</p>
      <div style={{ marginTop: "10px" }}>
        {displayCountryDesc(country, selectedOption)}
      </div>
      <div className="inline" style={{ marginRight: "15px" }}>
        <BOListTemplates country={country} />
        <DocuTemplates country={country} />
      </div>
      <div className="inline" style={{ width: "65%" }}>
        <p className="subTitle">Thank you, we have received your file.</p>
        <p>
          A confirmation message is now being sent to:
          <br />
          <strong>{fileUploadData.email}</strong>
          <br />
          {fileUploadData.ccFirst && (
            <>
              <strong>{fileUploadData.ccFirst}</strong>
              <br/>
            </>
          )}
          {fileUploadData.ccSecond && (
            <>
              <strong>{fileUploadData.ccSecond}</strong>
              <br/>
            </>
          )}          
          To <strong>print</strong> all details please{" "}
          <ReactToPrint
            trigger={() => <button className="buttonAsText">click here</button>}
            content={() => componentRef.current}
          />
          . (expires in 4h)
        </p>
        <p style={{ fontWeight: "bold" }}>Upload Information</p>
        <hr />
        <div className="inline" style={{ width: "25%" }}>
          Reference Code:
        </div>
        <div className="inline" style={{ width: "75%" }}>
          <strong>{fileUploadData.returnedReferenceCode}</strong>
        </div>
        <div className="inline" style={{ width: "25%" }}>
          Timestamp:
        </div>
        <div className="inline" style={{ width: "75%" }}>
          {fileUploadData.returnedTimeStamp}
        </div>
        <div className="inline" style={{ width: "25%" }}>
          File:
        </div>
        <div className="inline" style={{ width: "75%" }}>
          {fileUploadData.attachedFileName}
        </div>
        <div className="inline" style={{ width: "25%" }}>
          Size:
        </div>
        <div className="inline" style={{ width: "75%" }}>
          {Number(fileUploadData.attachedFileSize) / 1000} kB
        </div>

        <div
          className="inline"
          style={{
            marginTop: "20px",
            backgroundColor: "#00A5C0",
            width: "100%",
            paddingTop: "15px",
            paddingBottom: "15px",
          }}
        >
          <div style={{ marginLeft: "10px" }}>
            Do you want to upload another BO List?
          </div>
        </div>
        <div className="clearBoth" />
        <div
          style={{
            padding: "20px",
            backgroundColor: "#f1f0f0",
          }}
        >
          <div
            style={{
              position: "relative",
              height: "20px",
            }}
          >
            <img
              src={arrow_gray}
              alt=""
              width="15"
              height="9"
              style={{
                margin: "0 0 0 0",
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            ></img>
            <div
              id="sameMarket"
              onClick={handleClick}
              style={{ marginLeft: "20px" }}
            >
              <button
                className="buttonaslink"
                id="sameMarket"
                onClick={handleClick}
              >
                With the same market and security type?
              </button>
            </div>
          </div>
          <div
            style={{
              height: "20px",
              position: "relative",
            }}
          >
            <img
              src={arrow_gray}
              alt=""
              width="15"
              height="9"
              style={{
                margin: "0 0 0 0",
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            ></img>
            <div style={{ marginLeft: "20px" }}>
              <button
                className="buttonaslink"
                id="diffMarket"
                onClick={handleClick}
              >
                For a different market?
              </button>
            </div>
          </div>
          <div
            style={{
              height: "20px",
              position: "relative",
            }}
          >
            <img
              src={arrow_gray}
              alt=""
              width="15"
              height="9"
              style={{
                margin: "0 0 0 0",
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            ></img>
            <div
              style={{
                marginLeft: "20px",
              }}
            >
              <button
                className="buttonaslink"
                id="finished"
                onClick={handleClick}
              >
                No thanks, I'm finished.
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUploadConfirmation;
